import ContentPreview from "./detail-panel/ContentPreview";
import ContentTags from "./detail-panel/ContentTags";
import ContentMetadataPanel from "./detail-panel/ContentMetadataPanel";
import { useContentDetailPanel } from "@/hooks/useContentDetailPanel";
import { ContentCard } from "@/components/ui/content-card";

interface ContentDetailPanelProps {
  contentItem: any;
  onUpdate: () => void;
}

const ContentDetailPanel = ({ contentItem, onUpdate }: ContentDetailPanelProps) => {
  const {
    url,
    contentType,
    collectionId,
    notes,
    isSaving,
    collections,
    tags,
    handleUrlChange,
    handleContentTypeChange,
    handleNotesChange,
    handleNotesSave,
    handleCollectionChange,
    contentItemId
  } = useContentDetailPanel(contentItem, onUpdate);

  // Debug log the content item color
  console.log("[COLOR DEBUG] ContentDetailPanel rendering with item:", {
    id: contentItem?.id, 
    title: contentItem?.title,
    collection_color: contentItem?.collection_color,
    content_type: contentItem?.content_type
  });

  // Ensure we have a valid color
  const cardColor = contentItem?.collection_color || "#6B7789";

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {/* Content preview section with Tags below */}
      <div className="flex flex-col space-y-4 h-full">
        {/* Replace ContentCard with a regular div for the thumbnail */}
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-800 overflow-hidden">
          <ContentPreview contentItem={contentItem} onUpdate={onUpdate} />
        </div>
        <ContentTags contentId={contentItemId} />
      </div>

      {/* Metadata panel - Keep the color coding here */}
      <div className="h-full">
        <ContentCard 
          color={cardColor}
          isClickable={false}
          fullHeight={true}
        >
          <ContentMetadataPanel
            contentItem={contentItem}
            url={url}
            contentType={contentType}
            collectionId={collectionId}
            notes={notes}
            isSaving={isSaving}
            collections={collections}
            handleUrlChange={handleUrlChange}
            handleContentTypeChange={handleContentTypeChange}
            handleCollectionChange={handleCollectionChange}
            handleNotesChange={handleNotesChange}
            handleNotesSave={handleNotesSave}
          />
        </ContentCard>
      </div>
    </div>
  );
};

export default ContentDetailPanel;
